import React from "react";
import { Container, Box, Typography, Button, Grid, Paper } from "@mui/material";
import { theme } from "./utils/theme";
import products from "./utils/ProductsMockData.json";

function ProductDetails({ product, onBack }) {
  return (
    <>
      <Grid container spacing={2}>
        {products.map((product) => (
          <Grid
            item
            size={{ md: 6, lg: 4 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Container sx={{ py: 8, mt: 2 }}>
              <Paper
                elevation={6}
                sx={{
                  p: { xs: 2, md: 4 },
                  borderRadius: "20px",
                  background: theme.palette.background.paper,
                  backdropFilter: "blur(10px)",
                }}
              >
                <Grid container spacing={4} direction="column">
                  <Grid item>
                    <Box
                      sx={{
                        height: { xs: 300, md: 400, lg: 700 },
                        borderRadius: "15px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        key={0}
                        src={require(process.env.PUBLIC_URL +
                          product.images[0])}
                        alt={product.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://placehold.co/600x400/333/FFF?text=Image+Error";
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h4"
                      component="h1"
                      gutterBottom
                      fontWeight="bold"
                    >
                      {product.name}
                    </Typography>
                    <Typography variant="body1" paragraph color="#6b686d">
                      {product.description}
                    </Typography>
                    <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
                      <Button variant="contained" color="primary" size="large">
                        View Details
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Container>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default ProductDetails;
